module.exports = __webpack_public_path__ + "static/img/contact_img1.b06be7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/contact/imgs/contact_img1.png
// module id = EDDF
// module chunks = 1